<template>
  <div>
     <Alert :closable="false" type="warning" class="alert-default" v-if="!hideQuotes()">
          <svgicon name="icon-risk" width="13" height="13" />
          {{$t('INDENT_NO_VIEW_TRANSPORTER_QUOTES_PERMISSION')}}
      </Alert>
    <div v-if="hideQuotes()">
      <div class="buttons-top">
        <div class="bid-expiry text-grey-dark">
        {{$t('INDENT_BID_EXPIRY')}}: <span class="text-bold">{{ $moment(rfqData.expires_at).format('DD MMM YYYY | hh:mm A') }}</span>
        </div>
        <div class="buttons-grp">
          <div class="popup-empty" v-if="hideQuotes() && ([1,3].includes(rfqData.status) || showFallbackButton) && !showAction() && !isApprovalPending && !isRfqApprovalPage">
            <Button type="secondary" size="mini" @click="$emit('reindent', rfqData)">{{$t('INDENT_RE_INDENT')}}</Button>
          </div>
          <div class="btn-group" v-else-if="isApprovalPending && hideQuotes() && (!showButtons() || $hasFeature('rfq_fallback_enabled')) && hidebuttons() && !isRfqApprovalPage">
            <Button
              v-if="$hasPermission('rfq_update')"
              type="secondary" size="mini"
              :disabled="!rfqData.user_action"
              @click="statusUpdate(RFQConstants.QuoteStatus.TRANSPORTER_ACCEPT)"
            >{{$t('INDENT_REJECT')}}</Button>
            <Button
              v-if="$hasPermission('rfq_update')"
              type="primary" size="mini" class="ml-5"
              :disabled="!rfqData.user_action"
              @click="approveQuote"
            >{{$t('INDENT_APPROVE')}}</Button>
          </div>

          <div class="btn-group" v-else-if="hideQuotes() && showAction() && (!showButtons() || showFallbackButton) && hidebuttons() && !isRfqApprovalPage">
              <!--   RFQ COUNTER OFFER -->
              <Button
                v-if="showCounterOfferCheck && showCounterOffer"
                type="secondary" size="mini" @click="cancelCounterOffer"
                >
                {{ $t('CANCEL') }}
              </Button>
              <Button
              v-if="showCounterOfferCheck && showCounterOffer"
              type="secondary" size="mini" @click="submitCounterOffer" :class="{'disabled': disableSendCounterOffer }"
              :disabled="disableSendCounterOffer">
              {{  $t('SEND_COUNTER') }}
            </Button>
            <Button
              v-if="showCounterOfferCheck && !showCounterOffer"
              type="secondary" size="mini" @click="toggleCounterOffer">
            {{ $t('COUNTER_OFFER') }}
            </Button>
            <span v-if="$hasPermission('rfq_update') && !showCounterOffer">
              <!-- Reject all -->
              <Button
                v-if="rfqComment"
                type="secondary" size="mini"
                :disabled="!rfqComment || this.$hasPermission('hide_rfq_quotes_price')"
                @click="rejectAll"
              >{{$t('INDENT_REJECT_ALL')}}</Button>
              <Tooltip
                v-else
                popper-class="max-width"
                :open-delay="200"
                effect="dark"
                placement="bottom-start">
                  <div slot="content">{{$t('INDENT_COMMENT_MANDATORY')}}</div>
                  <span class="pointer">
                    <Button
                      type="secondary" size="mini"
                      :disabled="!rfqComment || this.$hasPermission('hide_rfq_quotes_price')"
                    >{{$t('INDENT_REJECT_ALL')}}</Button>
                  </span>
              </Tooltip>

              <!-- Select -->
              <Button
                v-if="!disableSelect"
                type="primary" size="mini"
                :disabled="disableSelect"
                @click="statusUpdate(RFQConstants.QuoteStatus.SHIPPER_SELECT)"
              >{{$t('SELECT')}}</Button>
              <Tooltip
                v-else
                popper-class="max-width"
                :open-delay="200"
                effect="dark"
                placement="bottom-start">
                  <div slot="content">{{$t('INDENT_SELECT_MANDATORY')}}</div>
                  <span class="pointer">
                    <Button
                      type="secondary" size="mini"
                      :disabled="disableSelect"
                    >{{$t('SELECT')}}</Button>
                  </span>
              </Tooltip>
            </span>

          </div>
        </div>
      </div>
      <div class="pl-0 d-inline-flex pr-20 text-blue-dark2" v-if="showHistoricalPrice()">
        <P class="text-blue-dark2">{{$t('BIDS_HISTORICAL_PRICE')}} : <strong>{{getHistoricalPrice}}</strong></P>
      </div>
      <div class="px-0 d-inline-flex text-blue_dark2" v-if="showCeilingPrice()">
        <P class="text-blue-dark2">{{$t('BIDS_CEILING_PRICE')}} : <strong>{{getCeilingPrice()}}</strong></P>
      </div>
      <div v-if="showCounterOffer">
        <Form class="form-default form-triple mt-5">
            <FormItem label="Counter offer">
              <Input placeholder="Enter Counter offer" v-numericOnly v-model="counteroffer" />
            </FormItem>
        </Form>
      </div>
      <div class="tablepanel popover-minwidth" v-if="!error">
        <Table
          :data="rfqData.quotes"
          stripe
          class="table-striped bordered my-15"
          max-height="250px"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
        >
        <table-column v-if="showCounterOffer" type="selection" width="50" :selectable="isRowSelectable"/>
          <!-- Transporters Column -->
          <table-column
            fixed
            :label="$t('INDENT_TRANSPORTERS')"
            width="210"
          >
            <template slot-scope="scope">
              <div class="flex-center">
                <radio
                v-model="selected"
                :label="scope.row.transporter.id" v-if="history && !showCounterOffer" :disabled="disableQuote(scope.row.status)">
                  <Tooltip v-if="getTooltipContent(scope.row.status, rfqData.status)"
                    placement="top-start"
                    :disabled="!disableQuote(scope.row.status)"
                  >
                    <div slot="content">{{ getTooltipContent(scope.row.status, rfqData.status) }}</div>
                    <span class="trimmed d-unset">
                      <Ellipsis :text="scope.row.transporter.name" :length="18" />
                    </span>
                  </Tooltip>
                  <span v-else class="trimmed d-unset">
                    <Ellipsis :text="scope.row.transporter.name" :length="18" />
                  </span>
                </radio>
                <div v-else>
                  <span class="trimmed d-unset">
                    <Ellipsis :text="scope.row.transporter.name" :length="18" />
                  </span>
                </div>
                <div class="text-xxs status status-teal" v-if="scope.row.status === RFQConstants.QuoteStatus.SHIPPER_SELECT">
                  {{ $t('SELECTED') }}
                </div>
                <div class="text-xxs status status-red" v-else-if="scope.row.user_rejected && !isApprovalPending">
                  {{ $t('REJECTED') }}
                </div>
              </div>
            </template>
          </table-column>

          <!-- Vehicle Type Column -->
          <table-column
            v-if="hideQuotes()"
            :label="$t('INDENT_VEHICLE_TYPE')"
            width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.vehicle_type">
                <Ellipsis :text="scope.row.vehicle_type.short_form" :length="12" />
              </div>
            </template>
          </table-column>
          <table-column
            v-if="hideQuotes()"
            width="180"
          >
           <template slot="header" slot-scope="scope">
              <span>{{$t('INDENT_BASE_QUOTE')}}</span>
              <span v-if="rfqData.quotes && rfqData.quotes.length && getFreightUnit(rfqData.quotes[0].freight_unit)">
                ( {{ getFreightUnit(rfqData.quotes[0].freight_unit).name || '-' }} )
              </span>
            </template>
            <template slot-scope="scope">

              <div v-bind:class="getClass(scope.row)" v-if="hideQuotes()">
              <div v-if="scope.row.freight_charge && showFreightCharges()">{{scope.row.freight_charge}}</div>
              <div v-else-if="scope.row.freight_charge" > <svgicon name="Cost" width="13" height="13" />  </div>
              <div v-if="scope.row.vehicle_diff_percent != null">
                <span v-if="scope.row.vehicle_diff_percent > 0">{{ Number(scope.row.vehicle_diff_percent) }} kg</span>
                <span v-else-if="scope.row.vehicle_diff_percent < 0">{{ Number(scope.row.vehicle_diff_percent * -1) }} kg</span>
                <svgicon
                  name="primaryarrow"
                  width="10"
                  height="10"
                  v-if="scope.row.vehicle_diff_percent > 0"
                  :original="true"
                  class="psvg svg-rotate"
                />
                <svgicon
                  name="secarrow"
                  width="10"
                  height="10"
                  v-else-if="scope.row.vehicle_diff_percent < 0"
                  :original="true"
                  class="psvg svg-rotate"
                />
              </div>
              <div v-if="scope.row.diff_percent!=null" class="pl-10">
                <span v-if="scope.row.diff_percent>0" class="pr-10">{{Number(scope.row.diff_percent).toFixed(2)}}%</span>
                <span v-else class="pr-10">{{Number(scope.row.diff_percent*-1).toFixed(2)}}%</span>
                <svgicon
                  name="secarrow"
                  width="10"
                  height="10"
                  v-if="scope.row.diff_percent>0"
                  :original="true"
                  class="psvg"
                />
                <svgicon
                  name="primaryarrow"
                  width="10"
                  height="10"
                  v-else
                  :original="true"
                  class="psvg"
                />
              </div>
            </div>
            </template>
          </table-column>

          <!-- Rank Column -->
          <table-column
              v-if="hideQuotes() && $hasFeature('rank_transporter_quotes')"
              :label="$t('RANK')"
              width="80"
              align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.rank && scope.row.rank > 0" class="rank-badge">
                <span class="rank-default">#{{ scope.row.rank }}</span>
              </div>
              <div v-else class="rank-badge">-</div>
            </template>
          </table-column>

          <table-column
            v-if="hideQuotes() && $hasFeature('freight_budget_visibility')"
            :label="$t('INDENT_IDEAL_FREIGHT_PERCENTAGE')"
            width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.ideal_freight_percentage && scope.row.ideal_freight_percentage >0">
                <Ellipsis :text="scope.row.ideal_freight_percentage + '%'" :length="12" />
              </div>
              <div v-else-if = "scope.row.freight_charge && scope.row.freight_charge > 0">
                <Ellipsis :text="'-'" :length="12" />
              </div>
            </template>
          </table-column>
          <table-column
            v-if="hideQuotes() && $hasFeature('freight_budget_visibility')"
            :label="$t('INDENT_COMPUTED_FREIGHT_PERCENTAGE')"
            width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.computed_freight_percentage && scope.row.computed_freight_percentage > 0">
                <Ellipsis :text="scope.row.computed_freight_percentage + '%'" :length="12" />
              </div>
              <div v-else-if = "scope.row.freight_charge && scope.row.freight_charge > 0">
                <Ellipsis :text="'-'" :length="12" />
              </div>
            </template>
          </table-column>
          <table-column
            v-if="hideQuotes() && $hasFeature('freight_budget_visibility')"
            :label="$t('INDENT_BUDGET_BREACHED')"
            width="150"
          >
            <template slot-scope="scope">
        <div v-if="scope.row.is_breached">
           {{ $t('YES') }}
        </div>
        <div v-else-if="!scope.row.is_breached && scope.row.computed_freight_percentage && scope.row.computed_freight_percentage > 0">
          {{ $t('NO') }}
        </div>
        <div v-else>
          <Ellipsis :text="'-'" :length="12" />
        </div>
            </template>
          </table-column>
          <!-- Base Quote Column -->
          <!-- <table-column
            v-if="hideQuotes()"
            width="180"
          >
            <template slot="header" slot-scope="scope">
              <span>{{$t('INDENT_BASE_QUOTE')}}</span>
              <span v-if="rfqData.quotes && rfqData.quotes.length">( {{ getFreightUnit(rfqData.quotes[0].freight_unit).name }} )</span>
            </template>
            <template slot-scope="scope">
              <div v-if="hideQuotes() && scope.row.vehicle_diff_percent != null">
                <span v-if="scope.row.vehicle_diff_percent > 0">{{ Number(scope.row.vehicle_diff_percent) }} kg</span>
                <span v-else-if="scope.row.vehicle_diff_percent < 0">{{ Number(scope.row.vehicle_diff_percent * -1) }} kg</span>
                <svgicon
                  name="primaryarrow"
                  width="10"
                  height="10"
                  v-if="scope.row.vehicle_diff_percent > 0"
                  :original="true"
                  class="psvg svg-rotate"
                />
                <svgicon
                  name="secarrow"
                  width="10"
                  height="10"
                  v-else-if="scope.row.vehicle_diff_percent < 0"
                  :original="true"
                  class="psvg svg-rotate"
                />
              </div>
            </template>
          </table-column> -->

          <!-- Remarks Column -->
          <table-column
            v-if="hideQuotes()"
            :label="$t('INDENT_REMARKS')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.quote_remarks">
                <Ellipsis :text="scope.row.quote_remarks" :length="20" />
              </span>
            </template>
          </table-column>
          <table-column >
            <template slot-scope="scope">
              <span v-if="scope.row.shipper_counter_offer"
              class="counter-bg text-xs" style="position: absolute;right: 30px;"> C {{ scope.row.shipper_counter_offer }}</span>
            </template>
          </table-column>
        </Table>
        <Form class="form-default form-multi mt-5" v-if="hideQuotes() && showAction() && (!showButtons() || showFallbackButton) && hidebuttons()">
          <FormItem  :label="$t('INDENT_REASON')">
            <Input type="text" v-model="rfqComment" :placeholder="$t('INDENT_ENTER_REASON')" />
          </FormItem>
        </Form>

    <!-- <div class="new">
      <div class="table" v-if="rfqData.quotes && rfqData.quotes.length > 0">

        <div class="table-header table-headborder">
          <div class="table-row">
            <div class="table-th w250">{{$t('INDENT_TRANSPORTERS')}}</div>
            <div class="table-th w150" v-if="hideQuotes()">{{$t('INDENT_VEHICLE_TYPE')}}</div>
            <div class="table-th w250" v-if="hideQuotes()">{{$t('INDENT_BASE_QUOTE')}} <span v-if="rfqData.quotes.length">( {{ getFreightUnit(rfqData.quotes[0].freight_unit).name }} )</span></div>
            <div class="table-th w100" v-if="hideQuotes()">{{$t('INDENT_REMARKS')}}</div>
            </div>
          </div>
        </div>
        <radio-group v-model="selected" class="table-bgcolor popscroll">
          <div class="table-row table-rowbg" :class="[hideQuotes() && quote.diff_percent != null ? quote.diff_percent>0 ? 'table-secborder' : 'table-primaryborder' : 'table-transparentborder']"
            v-for="quote in rfqData.quotes" :key="quote.transporter.id">
            <div class="table-td w250">
              <div class="flex-center">
                <radio :label="quote.transporter.id" v-if="history" :disabled="disableQuote(quote.status)">
                  <Tooltip v-if="getTooltipContent(quote.status, rfqData.status)"
                    placement="top-start" :disabled="!disableQuote(quote.status)">
                    <div slot="content">{{getTooltipContent(quote.status, rfqData.status)}}</div>
                    <span class="trimmed d-unset">
                      <Ellipsis :text="quote.transporter.name" :length="18" />
                    </span>
                  </Tooltip>
                  <span v-else class="trimmed d-unset">
                    <Ellipsis :text="quote.transporter.name" :length="18" />
                  </span>
                </radio>
                <div v-else>
                  <span class="trimmed d-unset">
                    <Ellipsis :text="quote.transporter.name" :length="18" />
                  </span>
                </div>
                <div class="text-xxs status status-teal" v-if="(quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT)">
                  {{ $t('SELECTED') }}
                </div>
                <div class="text-xxs status status-red" v-else-if="quote.user_rejected && !isApprovalPending">
                  {{ $t('REJECTED') }}
                </div>
              </div>
            </div>
            <div class="table-td w100" v-if="hideQuotes()">
              <div v-if="quote.vehicle_type">
                <Ellipsis :text="quote.vehicle_type.short_form" :length="12" />
              </div>
            </div>
            <div class="table-td w75">
              <div v-if="hideQuotes() && quote.vehicle_diff_percent!=null">
                <span v-if="quote.vehicle_diff_percent>0">{{Number(quote.vehicle_diff_percent)}} kg</span>
                <span v-else-if="quote.vehicle_diff_percent<0">{{Number(quote.vehicle_diff_percent * -1 )}} kg</span>

                <svgicon
                  name="primaryarrow"
                  width="10"
                  height="10"
                  v-if="quote.vehicle_diff_percent>0"
                  :original="true"
                  class="psvg svg-rotate"
                />
                <svgicon
                  name="secarrow"
                  width="10"
                  height="10"
                  v-else-if="quote.vehicle_diff_percent<0"
                  :original="true"
                  class="psvg svg-rotate"
                />
              </div>
            </div>

            <div v-bind:class="getClass(quote)" v-if="hideQuotes()">
              <div v-if="quote.freight_charge && showFreightCharges()">{{quote.freight_charge}}</div>
              <div v-else-if="quote.freight_charge" > <svgicon name="Cost" width="13" height="13" />  </div>
            </div>

            <div class="table-td w100" v-if="hideQuotes() && quote.diff_percent!=null">
              <span v-if="quote.diff_percent>0">{{Number(quote.diff_percent).toFixed(2)}}%</span>
              <span v-else>{{Number(quote.diff_percent*-1).toFixed(2)}}%</span>
              <svgicon
                name="secarrow"
                width="10"
                height="10"
                v-if="quote.diff_percent>0"
                :original="true"
                class="psvg"
              />
              <svgicon
                name="primaryarrow"
                width="10"
                height="10"
                v-else
                :original="true"
                class="psvg"
              />
            </div>
            <div class="table-td w-200" v-if="hideQuotes()">
              <span v-if="quote.quote_remarks">
                <Ellipsis :text="quote.quote_remarks" :length="20" />
              </span>
              <span v-else>
              </span>
            </div>
            <span class="counter-bg text-xs" style="position: absolute;right: 30px;">C 1500</span>
            </div>
          </radio-group>
          <div class="reason-footer">
          <div class="reason-input" v-if="hideQuotes() && showAction() && !showButtons() && hidebuttons()">
            <label class="reason-text">{{$t('INDENT_REASON')}}:</label>
            <input type="text" v-model="rfqComment" :placeholder="$t('INDENT_ENTER_REASON')" />
          </div>
         </div>
        </div> -->
      </div>
    </div>

    <div class="status-msg my-md" v-if="!rfqData || error">
      <span>
        <svgicon name="empty-timeline" width="180" height="130" :original="true" />
        <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
      </span>
    </div>

    <!-- Fallback uses the existing Select button flow via statusUpdate() -->
    <div class="status-msg my-md" v-if="rfqData && rfqData.quotes && !rfqData.quotes.length ">
      <span>
        <svgicon name="empty-timeline" width="180" height="130" :original="true" />
        <p class="ml-30">{{$t('INDENT_BID_IN_PROGRESS')}}</p>
      </span>
    </div>
    <Collapse  accordion class="collapse-slider mx-15" v-if="hideQuotes() && !isRfqApprovalPage">
    <CollapseItem
    :title="$t('INDENT_PREVIOUSLY_ACCEPTED_QUOTES')">
      <div class="tablepanel" v-if="!error">
        <div class="new" v-if="rfqData.accept_log && rfqData.accept_log.source">
          <div class="table" v-if="rfqData && rfqData.accept_log && rfqData.accept_log.source">
            <div class="table-header table-headborder">
              <div class="table-row" >
                <div class="table-th w120">{{$t('ACCEPTED ON')}}</div>
                <div class="table-th w200" v-if="hideQuotes()">{{$t('ROUTE')}}</div>
                <div class="table-th w150" v-if="hideQuotes()">{{$t('TRANSPORTER')}}</div>
                <div class="table-th w100" v-if="hideQuotes()">{{$t('VEHICLE TYPE')}}</div>
                <div class="table-th w150" v-if="hideQuotes()">{{$t('ACCEPTED QUOTE')}}  ({{currentClient.currency}}) </div>
              </div>
            </div>
          </div>
          <div class="table-row table-rowbg table-body" v-for="(quoteLog, index) in rfqData.accept_log.history" :key="index">
            <div class="table-td w120">
              <span class="table-body-td">
                    {{$moment(quoteLog.date_processed).format('DD MMM YYYY')}}
              </span>
            </div>
            <div class="table-td w200">
              <span class="table-body-td">
                {{rfqData.accept_log.source}} - <span class="ellipsis">{{rfqData.accept_log.destination.toString()}}</span>
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td">
                  <Ellipsis :text="quoteLog.transporter_id && quoteLog.transporter_id.vname ? quoteLog.transporter_id.vname : '-'" :length="12" />
              </span>
            </div>
            <div class="table-td w100">
              <span class="table-body-td ellipsis">
                  <Ellipsis :text="quoteLog.vehicle_id ? quoteLog.vehicle_id.short_form : '-'" :length="12" />
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td">
                <strong>
                  <template v-if="showFreightCharges()">{{ (quoteLog.freight && quoteLog.freight.rate) || '-' }}/</template>
                  <template v-else><svgicon name="Cost" width="13" height="13"/></template>
                  <span v-if="rfqData.quotes.length && quoteLog.freight && getFreightUnit(quoteLog.freight.unit) && showFreightCharges()">
                    {{ (getFreightUnit(quoteLog.freight.unit) && getFreightUnit(quoteLog.freight.unit).name) || '-' }}
                  </span>
                </strong>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
        </div>
      </div>
       </CollapseItem>
    </Collapse>
  <Collapse  accordion class="collapse-slider mx-15" v-if="hideQuotes() && rfqData.quotes && !isRfqApprovalPage">
    <CollapseItem
    :title="$t('INDENT_CURRENT_ACTIVE_CONTRACTS')" v-if="hideQuotes()">
      <div class="tablepanel popscroll">
        <div class="new"   v-if="activeContracts.length>0">
          <div class="table" v-if="activeContracts.length>0" >
            <div class="table-header table-headborder" v-if="activeContracts.length>0">
              <div class="table-row" >
                <div class="table-th w150" v-if="hideQuotes()" v-for="(header,index) in getActiveContractHeaders"
                          :key="index" >{{header.title}}</div>
                <div class="table-th w150" v-if="hideQuotes() && order.vehicle_type.type === 'PTL'">{{$t('INDENT_MIN_CHARGE')}} ({{currentClient.currency}})</div>
                <div class="table-th w150" v-if="hideQuotes() && order.vehicle_type.type === 'FTL'">{{$t('INDENT_POINT_CHARGE')}} ({{currentClient.currency}})</div>
              </div>
            </div>
          </div>
          <div class="table-row table-rowbg table-body" v-for="(contract, index) in activeContracts" :key="index">
            <div class="table-td w150">
              <span class="table-body-td">
                <Ellipsis
                      :text="contract[0] && contract[0].name ? (contract[0].name.split('-')[1] || contract[0].name) : '-'"
                      :length="12"
                    />
              </span>
            </div>
            <div class="table-td w200">
              <span class="table-body-td">
                <Ellipsis
                      :text="contract[0] && contract[0].name ? (contract[0].name.split('-')[1] || contract[0].name) : '-'"
                      :length="12"
                    />
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td ellipsis">
                  <Ellipsis :text="contract[0].vehicle_name" :length="12" />
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td ellipsis">
                  <template v-if="!$hasPermission('hide_contract_prices')">{{contract[0].rate}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span></template>
                  <template v-else><svgicon name="Cost" width="13" height="13"/></template>
              </span>
            </div>
            <div class="table-td w150" v-if="order.vehicle_type.type === 'PTL'">
              <span class="table-body-td">
                <strong>
                    <template v-if="!$hasPermission('hide_contract_prices')">{{contract[0].minimum_rate}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span></template>
                    <template v-else><svgicon name="Cost" width="13" height="13"/></template>
                </strong>
              </span>
            </div>
            <div class="table-td w150" v-if="order.vehicle_type.type === 'FTL'">
              <span class="table-body-td">
                <template v-if="!$hasPermission('hide_contract_prices')">{{contract[0].point_charges}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span></template>
                <template v-else><svgicon name="Cost" width="13" height="13"/></template>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
        </div>
      </div>
       </CollapseItem>
    </Collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { contractTypes, activecontractsHeaders } from '@/constants/order';
import { RFQConstants, sourceAndDestinationType } from 'pando-constants';


export default {
  props: ['order', 'isRfqApprovalPage'],
  data() {
    return {
      rfqComment: '',
      selected: null,
      rfqData: {},
      activeContracts: [],
      error: false,
      isLeastTransporter: false,
      contractTypes,
      history: true,
      activecontractsHeaders,
      RFQConstants,
      isReject: false,
      showCounterOffer: false,
      counteroffer: '',
      selectedTransporterIds: [],
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      currentClient: 'app/currentClient',
    }),
    isApprovalPending() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.find(_quote => _quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT)
      );
    },
    disableSelect() {
      const selectedTransporter = this.selected;
      if (selectedTransporter === null) return true;
      const leastTransporter =
        this.rfqData && this.rfqData.quotes.length
          ? this.rfqData.quotes[0]
          : {};
      const isLeastTransporter =
        leastTransporter &&
        leastTransporter.transporter.id == selectedTransporter;
      const isRemarkMandate =
        (this.configurations.indentConfig &&
          this.configurations.indentConfig
            .rfq_remarks_mandate_not_least_trans) ||
        false;
      return isRemarkMandate && !isLeastTransporter && !this.rfqComment.length;
    },
    selectedVehicleTypeId() {
      if (this.selected) {
        const selectedQuote = this.rfqData.quotes.find(quote => quote.transporter.id === this.selected);
        return selectedQuote.vehicle_type.id;
      }
      return null;
    },
    getHistoricalPrice() {
      return this.rfqData && this.rfqData.historical_price;
    },
    getActiveContractHeaders() {
      return [
        ...this.activecontractsHeaders,
      ];
    },
    disableSendCounterOffer() {
      return (!this.counteroffer || !this.selectedTransporterIds.length);
    },
    showCounterOfferCheck() {
      return this.$hasPermission('counter_offer') && this.$hasFeature('counter_offer');
    },
    showFallbackButton() {
      // Only show fallback when transporter has FAILED (second time, not first)
      // 2=indent_rejected, 16=truck_rejected, 20=indent_assign_due(SLA),
      // 21=indent_accept_due(SLA), 22=indent_arrived_due(SLA),
      // 25=requested (RFQ expired, no bids, indent kept alive by rfq_prevent_auto_cancel)
      const failedStatuses = [2, 16, 20, 21, 22, 25];
      return (
        this.$hasFeature('rfq_fallback_enabled') &&
        this.$hasPermission('rfq_update') &&
        this.$hasPermission('rfq_fallback_reselect') &&
        this.order.is_open_rfq &&
        failedStatuses.includes(this.order.status) &&
        !this.isApprovalPending
      );
    },
  },
  async created() {
    this.loadActiveContract();
    this.load();
  },

  mounted() {},

  methods: {
    toggleCounterOffer() {
      this.showCounterOffer = true;
    },
    async submitCounterOffer() {
      this.selected = '';
      if (!this.counteroffer) {
        this.$errorMessage({ message: 'Enter Counter Offer' });
      } else if (!this.selectedTransporterIds.length) {
        this.$errorMessage({ message: 'Select the Transporter' });
      } else if (this.counteroffer && this.selectedTransporterIds.length > 0) {
        const payload = {
          orderNo: this.order.order_number,
          data: {
            transporter_ids: this.selectedTransporterIds,
            counter_offer: this.counteroffer,
            remarks: this.rfqComment,
          },
        };
        const result = await this.$store.dispatch('order/sendCounterOffer', payload);
        if (result && result.error) {
          this.$errorMessage({ message: result.error });
        } else {
          const successMessage = result.successMessage;
          this.$success({ message: successMessage });
          this.$emit('closeDrawer');
        }
        this.cancelCounterOffer();
      }
    },
    isRowSelectable(row) {
      return !row.disabled;
    },
    cancelCounterOffer() {
      this.showCounterOffer = false;
      this.counteroffer = '';
      this.$refs.multipleTable.clearSelection();
      this.selected = '';
    },
    getCeilingPrice() {
      return this.rfqData && this.rfqData.ceiling_price;
    },
    disableQuote(quoteStatus) {
      const { QuoteStatus } = RFQConstants;
      if (this.isApprovalPending || this.$hasPermission('hide_rfq_quotes_price')) {
        return quoteStatus !== QuoteStatus.SHIPPER_SELECT;
      }
      return [QuoteStatus.QUOTE_SENT, QuoteStatus.SHIPPER_ACCEPT,
        QuoteStatus.SHIPPER_REJECT, QuoteStatus.TRANSPORTER_REJECT].includes(quoteStatus);
    },
    showCeilingPrice() {
      return this.$hasPermission('view_rfq_ceiling_price') && this.rfqData &&
      (this.rfqData.ceiling_price || this.rfqData.ceiling_price === 0);
    },
    getClass(quote) {
      if (quote.diff_percent != null) {
        return 'table-td w150 d-flex';
      }
      return 'table-td w150';
    },
    getFreightUnit(unitId) {
      return this.contractTypes.find(contract => contract.id === unitId);
    },

    hideQuotes() {
      return !this.$hasPermission('hide_rfq_quotes');
    },
    showFreightCharges() {
      return !this.$hasPermission('hide_rfq_quotes_price');
    },
    hidebuttons() {
      return [0, 2, 3, 25, 20, 21, 22, 16].includes(this.order.status);
    },
    showHistoricalPrice() {
      return this.$hasPermission('view_rfq_historical_price') && this.rfqData &&
      (this.rfqData.historical_price || this.rfqData.historical_price === 0);
    },
    showAction() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.some(_quote => _quote.status === 3)
      );
    },
    showButtons() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.some(_quote => _quote.status === 2)
      );
    },
    hideRadiobutton() {
      this.history = false;
    },
    async statusUpdate(quoteStatus) {
      const userRejectedQuote = (quoteStatus === RFQConstants.QuoteStatus.TRANSPORTER_ACCEPT);
      const sendForApproval = (quoteStatus === RFQConstants.QuoteStatus.SHIPPER_SELECT);
      if (this.selected) {
        try {
          const payload = {
            orderNo: this.order.order_number,
            payload: {
              comment: this.rfqComment,
              userRejectedQuote,
              sendForApproval,
              quotes: [
                {
                  transporter_id: this.selected,
                  status: quoteStatus,
                  vehicle_type_id: this.selectedVehicleTypeId,
                },
              ],
            },
          };
          if (userRejectedQuote) {
            this.$emit('rejectQuote', payload);
          } else {
            const result = await this.$store.dispatch('order/rfqupdate', payload);
            if (result && result.errors) {
              this.$errorMessage({ message: result.errors });
            } else {
              const successMessage = result.successMessage || this.$t('INDENT_TRANSPORTER_ASSIGNMENT');
              this.$success({ message: successMessage });
              if (this.isRfqApprovalPage) {
                this.load();
                this.$emit('refreshPage');
              }
            }
            this.$emit('closeDrawer');
          }
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
      } else {
        this.$error({ message: this.$t('INDENT_SELECT_TRANSPORTER_TO_INDENT') });
      }
    },
    async approveQuote() {
      if (this.selected) {
        try {
          const result = await this.$store.dispatch('order/rfqupdate', {
            orderNo: this.order.order_number,
            payload: {
              isShipperApproval: true,
              comment: this.rfqComment,
              quotes: [
                {
                  transporter_id: this.selected,
                  status: RFQConstants.QuoteStatus.SHIPPER_ACCEPT,
                  vehicle_type_id: this.selectedVehicleTypeId,
                },
              ],
            },
          });
          if (result && result.errors) {
            this.$errorMessage({ message: result.errors });
          } else {
            const successMessage = result.successMessage || this.$t('INDENT_TRANSPORTER_ASSIGNED_SUCCESS_MSG');
            this.$success({ message: successMessage });
          }
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
        this.$emit('closeDrawer');
      } else {
        this.$error({ message: this.$t('INDENT_SELECT_TRANSPORTER_TO_INDENT') });
      }
    },
    getTooltipContent(quoteStatus, rfqStatus) {
      if (this.isApprovalPending) {
        return '';
      }
      switch (quoteStatus) {
        case 1: {
          if (rfqStatus === 4) {
            return this.$t('INDENT_BID_EXPIRED');
          }
          return this.$t('INDENT_TRANSPORTER_YET_TO_RESPOND');
        }
        case 2: {
          return this.$t('INDENT_ALREADY_ACCEPTED');
        }
        case 4: {
          return this.$t('INDENT_SHIPPER_REJECTED');
        }
        case 5: {
          return this.$t('INDENT_TRANSPORTER_REJECTED');
        }
        default: {
          return '';
        }
      }
    },
    async load() {
      try {
        this.error = false;
        const result = await this.$store.dispatch('order/getrfqtransporters', {
          orderNo: this.order.order_number,
        });
        if (result.error) {
          this.error = true;
        } else {
          this.rfqData = result;
        }
        if ((this.order.status !== 25) && this.order.order_type === 1 && this.rfqData.status !== 1) {
          if (!this.showFallbackButton) {
            this.history = false;
          }
        }
        if (this.rfqData && this.rfqData.quotes && this.rfqData.quotes.length) {
          const selectedQuote = this.rfqData.quotes.find(quote =>
            quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT);
          this.selected = selectedQuote ? selectedQuote.transporter.id : null;
        }
        if (this.isRfqApprovalPage) {
          this.$emit('updateRfqData', this.rfqData);
        }
      } catch (e) {
        this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
      }
    },
    async rejectAll() {
      const params = this.rfqData.quotes.map(item => ({
        transporter_id: item.transporter.id,
        status: RFQConstants.QuoteStatus.SHIPPER_REJECT,
      }));
      if (params.length) {
        try {
          await this.$store.dispatch('order/rfqupdate', {
            orderNo: this.order.order_number,
            payload: {
              comment: this.rfqComment,
              shipperRejected: true,
              quotes: params,
            },
          });
          this.$success({ message: this.$t('INDENT_UPDATED_SUCCESS_MSG') });
          this.history = false;
          this.$emit('closeDrawer');
          if (this.isRfqApprovalPage) {
            setTimeout(() => {
              this.$success({ message: this.$t('RFQ_REDIRECT_TO_INDENT_PAGE') });
              this.$router.push({ path: '/indents/outbound' });
            }, 2000);
          }
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
      }
      this.$emit('closeDrawer');
    },
    constructContractPayload() {
      const payload = {
        sources: [],
        destinations: [],
      };
      this.order.sources.forEach((sourceDetail) => {
        const source = {
          type: sourceDetail.type,
          location_id: sourceDetail.location_id,
        };
        if (source.type !== sourceAndDestinationType.CONSIGNEE) {
          source.gate_id = sourceDetail.gate_id;
        }
        payload.sources.push(source);
      });
      this.order.destinations.forEach((destinationDetail) => {
        const destination = {
          type: destinationDetail.type,
          location_id: destinationDetail.location_id,
          source_gate_id: destinationDetail.source_gate_id,
          source_location_id: destinationDetail.source_location_id,
        };
        if (destination.type !== sourceAndDestinationType.CONSIGNEE) {
          destination.gate_id = destinationDetail.gate_id;
        }
        payload.destinations.push(destination);
      });
      return payload;
    },
    handleSelectionChange(quotes) {
      const quoteLimit = 50;
      const isLimitReached = quotes.length >= quoteLimit;
      this.rfqData.quotes.forEach((quote) => {
        quote.disabled = isLimitReached && !quotes.includes(quote);
      });
      if (quotes.length > quoteLimit) {
        const limtedQuotes = quotes.slice(0, quoteLimit);
        this.$refs.multipleTable.clearSelection();
        limtedQuotes.forEach((quote) => {
          this.$refs.multipleTable.toggleRowSelection(quote, true);
        });
      }
      this.selectedTransporterIds = quotes.slice(0, quoteLimit).map(quote => quote.transporter.id);
    },
    async loadActiveContract() {
      try {
        const payload = this.constructContractPayload();
        if (payload.sources.length !== 0 && payload.destinations.length !== 0) {
          const result = await this.$store.dispatch(
            'indentV2/getContract',
            payload,
          );
          if (!result || result.error) {
            this.$errorMessage({
              message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
            });
          } else if (result && result.length) {
            result.forEach((contract) => {
              if (contract.transporters[0].vehicle_type === this.order.vehicle_type.type) {
                this.activeContracts.push(contract.transporters);
              }
            });
          }
        }
      } catch (err) {
        this.$errorMessage({
          message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
        });
      }
    },
  },
  watch: {
    selected(newVal) {
      this.$emit('updateSelected', newVal);
    },
    selectedVehicleTypeId(newVal) {
      this.$emit('updateSelectedVehicleTypeId', newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
$fontBold: "OpenSans-Bold";
.inprogress {
  margin: 0px;
  padding: 0 15px 10px;
  font-size: 14px;
  font-weight: normal;
  color: #646464;
}
.table{
  margin-top: 10px;
}
.table-body-td{
font-size: 1.2rem;
font-weight: normal;
text-transform:capitalize;
text-overflow: ellipsis;
}

.table-row {
  border: none;
}
.table-th {
  padding: 6px 4px !important;
  margin-left: -3px;
  align-content: center;
  align-items: center;
}
.table-bgcolor {
  display: block;
}
.trimmed {
  display: inline-block;
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.2rem;
}
.text-right {
  text-align: right;
}
.ml-5 {
  margin-left: 5px;
}

.buttons-top {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  .buttons-grp{
    margin-left: auto;
    order: 2;
  }
}
.reason-footer {
  display: flex;
  padding: 10px 10px 0 10px;
  float: left;
  width: 100%;
  .reason-input {
    width: 58%;
    padding: 6px 5px 15px;

    .reason-text {
      display: block;
      color: #234357;
      font-size: 1rem;
      text-transform: uppercase;
      padding-bottom: 5px;
      padding-left: 0;
    }
    input {
      width: 100%;
      padding: 5px 0;
      font-size: 1.2rem;
      border: none;
      outline: none;
      border-radius: 0;
    }
    .popup-empty {
      width: 100%;
      padding: 15px 10px 0;
      text-align: right;
    }
  }
}
.counter-bg{
  background: #FFF4E5CC;
  color: #F94200 !important;
  font-weight: 800;
  border-radius: 22px;
  padding: 2px 5px;
}
</style>
